const cookie = {
  cookieNode: null,
  cookieBtnNode: null,
  cookieName: 'dcookie',

  init() {
    this.cookieNode = document.querySelector('.js-cookie');

    if(this.cookieNode) {
      this.cookieBtnNode = this.cookieNode.querySelector('button');

      if(this.cookieBtnNode) {
        this.cookieBtnNode.addEventListener('click', () => this.handleClickBtn(), false);
      }

      this.checkCookie();
    }
  },

  handleClickBtn() {
    this.setCookie(this.cookieName);
    this.checkCookie();
  },

  checkCookie() {
    this.cookieNode.classList[this.getCookie(this.cookieName) ? 'remove' : 'add']('is-visible');
  },

  setCookie(name, value = true, days = 7) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

    const expires = `expires=${date.toUTCString()}`;

    document.cookie = `${name}=${value || ''}; ${expires}; path=/`;
  },

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    return parts.length === 2 ? parts.pop().split(';').shift() : false;
  },
};

export default cookie;



// WEBPACK FOOTER //
// ./scripts/modules/cookie.js